export default "__VITE_ASSET__V_TgJNxN__"